var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkHand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 71,
    viewBox: "0 0 89 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2827 3.02044C35.8031 1.23991 39.2828 1.84935 41.0549 4.38167C42.2409 6.07655 43.8336 8.64508 45.5431 11.8616C45.2672 10.6527 44.9953 9.62356 44.7494 8.80916C43.9671 6.21786 45.4775 3.496 48.123 2.7297C50.7684 1.9634 53.5472 3.44285 54.3296 6.03415C54.8347 7.70721 55.4197 10.0734 55.9566 12.9429C56.5259 11.644 57.7567 10.6664 59.2842 10.4746C61.5856 10.1856 63.689 11.7896 63.9822 14.0572C64.2404 16.0532 64.452 19.0047 64.4642 22.5752L64.4646 58.9999C64.4647 64.5228 59.9875 69 54.4646 69C48.9472 69 43.4298 69 37.9124 69C34.0464 69 30.871 65.8139 29.6826 62.1351C29.0502 60.1775 28.1648 58.1755 27.0054 56.4172C26.7409 55.8272 26.1263 54.8153 25.285 53.611C24.4906 52.4739 23.6749 51.4205 23.1941 50.831C21.2572 48.4566 21.7262 45.0498 24.2416 43.2216C26.757 41.3933 30.3664 41.836 32.3033 44.2104C32.7746 44.7881 33.5741 45.8061 34.4353 47.0051C34.4626 47.0112 34.4888 47.0173 34.5138 47.0233C34.6414 47.2407 34.8516 47.5687 35.1068 47.9187C35.5391 48.4617 36.0203 48.9674 36.5469 49.4233C37.5321 50.0584 39.3373 50.4153 41.1425 49.0974C41.4371 48.8824 41.6629 48.634 41.8333 48.3668C42.6563 47.0771 41.7395 45.4859 40.7471 44.3208L38.8127 42.0497C37.5814 40.6041 35.6067 40.0652 33.7801 40.5616C32.0798 41.0236 30.5914 41.3513 29.6974 41.5243C26.6647 42.1112 23.7334 40.1129 23.1502 37.0611C22.5669 34.0092 24.7023 31.6494 27.5854 30.4724C31.7397 28.7765 36.6397 26.1757 40.4994 27.7235C37.5546 19.97 33.937 13.7004 31.928 10.8296C30.1559 8.29725 30.7624 4.80098 33.2827 3.02044Z",
    fill: "white",
    stroke: "#7FA3FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9718 12.7843C56.5895 16.1729 57.2586 22.1541 57.516 24.7211",
    stroke: "#7FA3FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5487 11.622C46.9642 14.7025 50.0268 21.8645 50.9533 25.8691",
    stroke: "#7FA3FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.758 27.4137C41.611 28.0298 44.0045 29.9807 45.5486 30.8792",
    stroke: "#7FA3FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 39.0017C10 28.6963 14.6523 19.4617 22 13.2266M74.6723 22.5017C77.4295 27.388 79 33.0141 79 39.0017C79 43.2253 78.2186 47.2689 76.7904 51M12.2096 51C13.4612 54.2699 15.2096 57.2997 17.3641 60",
    stroke: "#97E9C6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38.7143C87 49.4596 82.9717 59.2688 76.3358 66.7286M84.8836 25.5C82.4983 18.2793 78.2112 11.9171 72.6119 7M6.01832 56.686C3.44072 51.2318 2 45.1404 2 38.7143C2 32.2881 3.44072 26.1968 6.01832 20.7425",
    stroke: "#97E9C6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkHand);
export default __webpack_public_path__ + "static/media/ok-hand.8c4abfe23754e684fe24e43c65077633.svg";
export { ForwardRef as ReactComponent };